module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEmpty) ? [_c('lxm-empty', {
    attrs: {
      "text": '登录灵析电脑版，可以新建活动哦～'
    }
  })] : [(_vm.blocked) ? [_c('lxm-blocked', {
    attrs: {
      "text": '如需在手机上查看数据，请登录电脑升级为付费版哦。'
    }
  })] : [_c('div', {
    staticClass: "page"
  }, [_c('div', [_c('transition-group', {
    attrs: {
      "name": "lxm-content-transition",
      "tag": "div",
      "mode": "out-in"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('lxm-activity-item', {
      key: item,
      attrs: {
        "id": item.id,
        "title": item.title,
        "value": item.signedUpUserCount,
        "valueSuffix": item.valueSuffix,
        "to": item.to
      }
    })
  }))], 1), _vm._v(" "), (_vm.hasMore) ? _c('lxm-more', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.moreClicked
    }
  }) : _vm._e()], 1)]]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8c224cec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c224cec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Activity/List.vue
// module id = 877
// module chunks = 0